import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface MarqueeProps extends Omit<BoxProps, 'children'> {
  /** Seconds for one full loop */
  duration?: number
  children: React.ReactNode
}

const Root = styled(Box)({
  overflow: 'hidden',
  padding: '20px 0',
  WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 12%, #000 88%, transparent)',
  maskImage: 'linear-gradient(90deg, transparent, #000 12%, #000 88%, transparent)',
})

const Track = styled(Box, {
  shouldForwardProp: (p) => p !== 'duration',
})<{ duration: number }>(({ duration }) => ({
  display: 'flex',
  gap: 56,
  width: 'max-content',
  animation: `ds-marquee ${duration}s linear infinite`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
  '@keyframes ds-marquee': {
    to: { transform: 'translateX(-50%)' },
  },
}))

function withKeyPrefix(node: React.ReactNode, prefix: string) {
  return React.Children.map(node, (child, i) =>
    React.isValidElement(child)
      ? React.cloneElement(child, { key: `${prefix}-${child.key ?? i}` })
      : child,
  )
}

/**
 * Infinite horizontal marquee with edge fade — the album-name ticker under
 * the Landing v2 hero. Pass children once; internally duplicated so the
 * `translateX(-50%)` loop is seamless.
 */
export function Marquee({ duration = 36, children, ...rest }: MarqueeProps) {
  return (
    <Root {...rest}>
      <Track duration={duration}>
        {withKeyPrefix(children, 'a')}
        {withKeyPrefix(children, 'b')}
      </Track>
    </Root>
  )
}
